import { HttpClient } from '@angular/common/http';
import {
  TRANSLOCO_LOADER,
  Translation,
  TranslocoLoader,
  TRANSLOCO_CONFIG,
  translocoConfig,
  TranslocoModule,
  TranslocoService 
} from '@ngneat/transloco';
import { Injectable, NgModule } from '@angular/core';
import { environment } from '../environments/environment';
import { Platform } from '@ionic/angular';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LanguageService } from './language.service';
import { APP_INITIALIZER } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private baseUrl: string;

  constructor(private http: HttpClient, private platform: Platform) {
    // Detectamos si la app está en Capacitor (Android/iOS) o en Web
    if (this.platform.is('capacitor')) {
      this.baseUrl = "assets/i18n/";  // Ruta local en móvil (emulador)
    } else {
      // En la web, seguir usando la URL definida en el entorno
      this.baseUrl = environment.translocoUrl;  // Usar la URL de entorno en web y servidor
    }
  }

  getTranslation(lang: string) {
    const url = `${this.baseUrl}${lang}.json`;

    return new Observable<Translation>((observer) => {
      fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Error loading translation: ${response.statusText}`);
          }
          return response.json();
        })
        .then((translations: Translation) => {
          observer.next(translations);
          observer.complete();
        })
        .catch((error) => {
          observer.error(error);
        });
    }).pipe(
      catchError((error) => {
        console.error('Error al cargar las traducciones:', error);
        throw error;
      })
    );
  }
}

export function initLanguages(langService: LanguageService, translocoService: TranslocoService) {
  return () =>
    langService.loadLanguages().then(langsRaw => {
      // Normalizar a minúsculas para que coincida con los archivos JSON
      const langs = langsRaw.map(l => l.toLowerCase());
      translocoService.setAvailableLangs(langs);
      translocoService.setDefaultLang(langs[0] || 'es');
    });
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    LanguageService,
    {
      provide: APP_INITIALIZER,
      useFactory: initLanguages,
      deps: [LanguageService, TranslocoService],
      multi: true
    },
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        fallbackLang: 'es',
        defaultLang: 'es', // Idioma por defecto seguro para evitar 404
        reRenderOnLangChange: true,
        prodMode: environment.production,
      })
    },
    { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader }
  ]
})
export class TranslocoRootModule {}
